


































































































import { ADD_TEMPLATE, MUTATE_TEMPLATE } from '@/store/modules/template';
import { Component, Mixins } from 'vue-property-decorator';
import { ProductTemplate, ProductTemplateContent } from '@/assets/interface/Product';
import { certificate, product } from '@/plugins/papybase/papybaseInit';
import { cloneDeep, forEach, map } from 'lodash';
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import InsertImage from '@/components/global/InsertImage.vue';
import InterfaceTranslatorMixin from '@/mixins/vue/InterfaceTranslatorMixin';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import OpenTemplateDialog from '@/components/dashboard/addProduct/OpenTemplateDialog.vue';
import ProductDetailsForm from '@/components/dashboard/addProduct/ProductDetailsForm.vue';
// import NameTag from '@/components/dashboard/addProduct/NameTag.vue';
import { ProductInfo } from '@luxtag/papybase';
import SaveTemplateDialog from '@/components/dashboard/addProduct/SaveTemplateDialog.vue';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import moment from 'moment';

const uuidv4 = require('uuid/v4');

@Component({
    components: {
        ProductDetailsForm,
        // NameTag,
        InsertImage,
        SaveTemplateDialog,
        OpenTemplateDialog,
        SimpleDialog,
    },
    $_veeValidate: { validator: 'new' },
})
export default class AddProduct extends Mixins(IsMobileMixin, InterfaceTranslatorMixin, GAErrorEvent) {
    public saveTemplateDialog = false;
    public openTemplateDialog = false;
    public showSimpleDialog = false;
    public finishButtonLoading = false;
    public copyToClibboardSnackBar = false;

    public messageHeader = '';
    public messageContent = '';

    public product: ProductTemplate = {
        productTemplate: '',
        id: null,
        name: {
            id: 0,
            title: '',
            content: '',
        },
        sku: {
            id: 1,
            title: '',
            content: '',
        },
        fields: [
            {
                id: 2,
                title: '',
                content: '',
            },
            {
                id: 3,
                title: '',
                content: '',
            },
        ],
        images: [],
        description: [0, 1],
    }

    public addProductEvent(action: string, label: any) {
        this.$ga.event('AddProduct', 'click', action, label);
    }

    public onOpenTemplateClick() {
        this.addProductEvent('Click open template', 'Open template');
        this.openTemplateDialog = true;
    }

    public async onSaveTemplateClick() {
        // if (await this.$validator.validateAll()) {
        this.addProductEvent('Click save button', 'Save');
        this.saveTemplateDialog = true;
        // }
        // eslint-disable-next-line
        // alert('Correct them errors!');
    }

    public async onSaveTemplate(productTemplate: string) {
        const aClone: any = cloneDeep(this.product);
        aClone.productTemplate = productTemplate;

        try {
            const theTemplate = await this.saveToPapybase(aClone);
            this.$store.commit(ADD_TEMPLATE, theTemplate);
            this.copyToClibboardSnackBar = true;
        } catch (error) {
            console.error(error);
        }
    }

    public async saveToPapybase(theProduct: ProductTemplate): Promise<ProductTemplate> {
        try {
            const addedProduct = await product.createProduct(
                this.jwt,
                theProduct.productTemplate,
                JSON.stringify(theProduct.name),
                JSON.stringify(theProduct.sku),
                JSON.stringify(theProduct.description),
                JSON.stringify(theProduct.fields),
                JSON.stringify(theProduct.images),
            );
            // update the id in the form
            this.product.id = addedProduct.id;
            this.product.updated = addedProduct.updatedAt;
            return this.translateProductInfoToProductTemplate(addedProduct);
        } catch (error) {
            this.errorEvent('createProduct', error);
            throw new Error(error);
        }
    }

    public async onReplaceTemplate(event: any) {
        const aClone: any = cloneDeep(this.product);
        aClone.productTemplate = event.productTemplate;
        aClone.id = event.id;

        try {
            const theTemplate = await this.replaceToPapybase(aClone);
            this.$store.commit(ADD_TEMPLATE, theTemplate);
        } catch (error) {
            this.errorEvent('replaceToPapybase', error);
            console.error('this error', error);
        }
    }

    public async replaceToPapybase(theProduct: ProductTemplate): Promise<ProductTemplate> {
        try {
            const productInfo: ProductInfo = {
                id: (theProduct.id) ? theProduct.id : -1,
                productTemplate: theProduct.productTemplate,
                name: JSON.stringify(theProduct.name),
                sku: JSON.stringify(theProduct.sku),
                description: JSON.stringify(theProduct.description),
                fields: JSON.stringify(theProduct.fields),
                image_url: JSON.stringify(theProduct.images),
            };
            const replacedProduct = await product.updateProductByID(
                this.jwt,
                productInfo,
            );
            // update the id in the form
            this.product.id = replacedProduct.id;
            this.product.productTemplate = replacedProduct.productTemplate;
            this.product.updated = replacedProduct.updatedAt;
            return this.translateProductInfoToProductTemplate(replacedProduct);
        } catch (error) {
            this.errorEvent('updateProductByID', error);
            console.error(error);
            throw new Error(error);
        }
    }

    public async onFinishClick() {
        this.addProductEvent('Click finish', 'Finish');
        if (await this.$validator.validateAll()) {
            try {
                // console.log(this.getPayload());
                this.finishButtonLoading = true;
                const res = await certificate.generateCertificateNem(
                    this.jwt,
                    this.product.sku.content,
                    JSON.stringify(this.getPayload()),
                    2,
                );

                this.$router.push('/products');
            } catch (error) {
                this.errorEvent('generateCertificateNem', error);

                if (error.message === 'FAILURE_INSUFFICIENT_BALANCE') {
                    this.messageHeader = 'Insufficient balance';
                    this.messageContent = 'You do not have enough balance, please contact info@luxtag.io';
                    this.showSimpleDialog = true;
                } else {
                    this.messageHeader = 'Failed';
                    this.messageContent = error.message;
                    this.showSimpleDialog = true;
                }
            } finally {
                this.finishButtonLoading = false;
            }
        } else {
            // eslint-disable-next-line
            // alert('Correct them errors!');
        }
    }

    public getPayload() {
        const payload: any = {
            Model: this.product.name.content,
            'Serial No.': this.product.sku.content,
        };

        for (const theProduct of this.product.fields) {
            payload[theProduct.title] = theProduct.content;
        }

        if (this.product.images.length > 0) {
            this.$set(payload, 'img', this.product.images[0]);
        }

        return payload;
    }

    // public getIdealPayload() {
    //     let payload: any = {
    //         Model: this.product.name.content,
    //         'Serial No.': this.product.sku.content,
    //     };

    //     for (const product of this.product.fields) {
    //         payload.data[product.title] = product.content;
    //     }

    //     if (this.product.images.length > 0) {
    //         payload.imgs = this.product.images;
    //     }

    //     return payload
    // }

    get jwt() {
        return this.$store.getters.getJwt;
    }

    get userData() {
        return this.$store.getters.getUserData;
    }
}
